import React, { Suspense } from 'react';
import {
  RowLayout,
  CardGrid,
  RowLoadingSkeleton,
} from '@portal/ui/bw-ui/dashboard/dashboardRow';
import { Event } from '@portal/types/nexudus/events';
import EventCard from './EventCard';
import { useDashboardEventsQuery } from '../hooks/useEvents';

const WIDGET_PROPS = {
  title: 'Upcoming Events',
  manageHref: '/events',
  manageLabel: 'See all events',
} as const;

const EventsList: React.FC<{ events: Event[] }> = ({ events }) => {
  if (events.length === 0) return null;

  return (
    <RowLayout {...WIDGET_PROPS}>
      <CardGrid>
        {events.map((event) => (
          <EventCard key={event.Id} event={event} />
        ))}
      </CardGrid>
    </RowLayout>
  );
};

const UpcomingEventsContent: React.FC = () => {
  const { data: featuredEvents } = useDashboardEventsQuery();
  return <EventsList events={featuredEvents ?? []} />;
};

const UpcomingEventsWidget: React.FC = () => (
  <Suspense fallback={<RowLoadingSkeleton {...WIDGET_PROPS} />}>
    <UpcomingEventsContent />
  </Suspense>
);

export default UpcomingEventsWidget;
